export const colorPalette = {
	white: '#FFFFFF',
	white1: 'rgba(255, 255, 255, 0.79)',
	white_opacity_10: 'rgba(241,241,241,0.1)',
	white100: '#FCFCFC',
	white500: '#D5D5D5',

	light1: '#FAFAFA',
	light2: '#E4E6E7',
	light3: '#D3D7D9',
	light4: '#AEB3B6',
	light5: '#898E93',
	light6: '#F9F9F9A8',
	tranquilPool100: '#F3FBFF',

	dark0: '#333333',
	dark1: '#383838',
	dark2: '#333',
	dark3: '#2C2C2C',
	dark4: '#252525',
	dark5: '#191919',
	dark6: '#121212',
	dark7: '#00000040',
	black: '#000',
	loadingBackground: 'rgba(0, 0, 0, 0.5)',
	modalBackdrop: 'rgba(0, 0, 0, 0.8)',

	oliveGreen: '#BCD13F',
	green: '#40BD87',
	radioGreen: '#37C778',
	highlightersTerminal: '#20EF66',
	drunkenDragonfly100: '#46DD8B',
	systemGreen1: '#39DB83',
	buttonGreen: '#40BD87',
	generateVideoAppHomeGreen: '#44E18A', // Will remove this

	rainbowBlue: '#36AAE2',
	blue3: '#498FF8',
	blue4: '#007BEC',

	purple1: '#BDACFF',
	purple2: '#9278FE',
	purple3: '#6B49F5',
	purple4: '#4023B5',
	purple5: '#2B1A72',

	tonal1: '#EEEAFD',
	tonal3: '#EDF4FF',
	tonal4: '#0D1F39',
	tonal5: '#172E39',
	tonal6: '#20536B',

	grey100: '#7B7B7B',
	grey600: '#1E1E1E',
	grey700: '#040404',

	vividBlue600: '#1124CA',

	systemYellow: '#FFB340',
	paleYellow: '#F4E47F',
	systemYellow_opacity_60: 'rgba(255, 179, 64, 0.60)',
	mandarinSorbet100: '#FFB74B',
	mandarinSorbet200: '#FFC46A',
	rainbowOrange: '#FFB25A',

	lightCoral: '#FFB4A6',
	systemRed1: '#FF6961',
	rainbowRed: '#EE5F55',
	rainbowPurple: '#9278FE',
	pricingNonCommercialRed: '#CF635B', // Will remove this

	palePink: '#F5CCC7',
	highlightersRoseBonbon: '#EC4898',
};
